import React from "react";

function IconEmail() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 21 20">
      <path
        fillRule="evenodd"
        d="M1.75 4c0-.41.34-.75.75-.75h16c.41 0 .75.34.75.75v12c0 .41-.34.75-.75.75h-16a.75.75 0 01-.75-.75V4zm2.75.75l6 5.25 6-5.25h-12zm13.25.9l-6.76 5.91a.75.75 0 01-.98 0l-6.76-5.9v9.59h14.5v-9.6z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default IconEmail;
